module.exports = __webpack_public_path__ + "img/Login-BG.17cc41f9.jpg";